import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for LabelsCatalog Action/Mutation Types. Use it in   labels/actions.js, labels/mutations.js and the Vuex Host Component
export const LabelsCatalogData = createActionTypeModel(
  "LabelsCatalogData"
);
export const LabelList = createActionTypeModel("LabelList");
export const LabelDetails = createActionTypeModel(
  "LabelDetails"
);
export const MetaData = createActionTypeModel("MetaData");
export const LabelRelatedContacts = createActionTypeModel(
  "LabelRelatedContacts"
);
export const LabelAccountsSetup = createActionTypeModel(
  "LabelAccountsSetup"
);

export const SET_LABEL_PRODUCT_FILES =
  "SET_LABEL_PRODUCT_FILES";
export const SET_LABEL_ARTWORK = "SET_LABEL_ARTWORK";

// export const FETCH_ONLY_LABELS = 'FETCH_ONLY_LABELS';
